export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 210;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
